/* import __COLOCATED_TEMPLATE__ from './seats-editor-card-wrapper-with-paywall.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();